import React, { FC } from 'react';
import { ApplePayButton } from './ApplePayButton';

export interface ApplePayProps {
  onClick: () => void;
  showApplePay?: boolean;
}

export const ApplePay: FC<ApplePayProps> = ({ onClick, showApplePay }) => {
  if (!showApplePay) return null;

  return <ApplePayButton onClick={onClick} />;
};
